import { takeLatest, call, put, select } from 'redux-saga/effects';

// Services
import { turnstilesApi } from 'services/apiDigitalTicket/turnstiles';

// Actions
import * as DialogsActions from 'store/ducks/dialogs/actions';
import * as SnackbarsActions from 'store/ducks/snackbars/actions';

// Constants
import { errorMessagersList } from 'helpers/errorMessagers';

import * as TurnstilesActions from './actions';
import { TurnstilesTypes } from './types';

function* listTurnstiles({
  payload,
}: ReturnType<typeof TurnstilesActions.listTurnstilesRequest>): any {
  try {
    const { body } = payload;
    yield put(DialogsActions.setOpenLoading({ title: 'Carregando dados' }));

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );
    const response = yield call(turnstilesApi.get, {
      data: {
        transportOperatorId: transportOperator.id,
        ...body,
      },
    });

    if (response.status === 200) {
      yield put(
        TurnstilesActions.listTurnstilesSuccess({
          turnstilesList: response.data,
        }),
      );
      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('employeesSales - listEmployees - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(TurnstilesActions.listTurnstilesFailure());
    yield put(DialogsActions.setClose());
  }
}

export const turnstilesSalesSagas = [
  takeLatest(TurnstilesTypes.LIST_TURNSTILES_REQUEST, listTurnstiles),
];
